var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "register-step status" }, [
    _vm.status === "waiting"
      ? _c("div", { staticClass: "register-status" }, [_vm._m(0), _vm._m(1)])
      : _vm.status === "success"
      ? _c("div", { staticClass: "register-status" }, [_vm._m(2), _vm._m(3)])
      : _vm.status === "error"
      ? _c("div", { staticClass: "register-status" }, [_vm._m(4), _vm._m(5)])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-status-image" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/icons/waiting.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-status-content" }, [
      _c("h3", [_vm._v("Płatność jest przetwarzana.")]),
      _c("p", [
        _vm._v(
          "Czekamy na odpowiedź od operatora płatności, o statusie transakcji."
        ),
      ]),
      _c("p", [
        _vm._v(
          "Potwierdzenie płatności zwykle trwa kilka minut. Możesz spokojnie zamknąć tę stronę. O zmianie statusu płatności poinformujemy Cię w wiadomości e-mail."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-status-image" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/icons/success.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-status-content" }, [
      _c("h3", { staticClass: "text-success" }, [
        _vm._v("Dziękujemy za opłacenie udziału."),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-status-image" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/icons/failed.svg"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "register-status-content" }, [
      _c("h3", { staticClass: "text-error" }, [
        _vm._v("Coś poszo nie tak i nie udało się zrealizować płatności."),
      ]),
      _c("p", [_vm._v("Spróbuj dokonać płatności jeszcze raz.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }